"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _imageLayout = _interopRequireDefault(require("./layouts/image-layout"));
var _noImageLayout = _interopRequireDefault(require("./layouts/no-image-layout"));
var _moreButton = _interopRequireDefault(require("./more-button"));
var _articleListing = _interopRequireDefault(require("./article-listing.props/article-listing.defaultProps"));
var _articleListing2 = _interopRequireDefault(require("./article-listing.props/article-listing.propTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString;
var ArticleCards = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ArticleCards, _React$Component);
  function ArticleCards(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      articleCount: 0,
      articlesDisplayed: 0
    };
    _this.changeLimitAmount = _this.changeLimitAmount.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = ArticleCards.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.getArticleLength();
    this.setArticlesDisplayed();
  };
  _proto.getArticleLength = function getArticleLength() {
    var articles = this.checkForArticles();
    this.setState({
      articleCount: articles.length
    });
  };
  _proto.setArticlesDisplayed = function setArticlesDisplayed() {
    var articles = this.checkForArticles();
    if (this.checkLimitSet() === ' ') {
      this.setState({
        articlesDisplayed: articles.length
      });
    } else {
      this.setState({
        articlesDisplayed: this.checkLimitSet()
      });
    }
  };
  _proto.checkLimitSet = function checkLimitSet() {
    var _this$props$data = this.props.data,
      pageSize = _this$props$data.pageSize,
      limit = _this$props$data.limit;
    if (renderEmptyString(limit) === ' ') {
      return renderEmptyString(pageSize);
    }
    return limit;
  };
  _proto.checkForArticles = function checkForArticles() {
    var articles = this.props.data.articles;
    if (renderEmptyString(articles) === ' ') {
      return [];
    }
    return articles;
  };
  _proto.changeLimitAmount = function changeLimitAmount() {
    var _this$state = this.state,
      articlesDisplayed = _this$state.articlesDisplayed,
      articleCount = _this$state.articleCount;
    if (articlesDisplayed + this.checkLimitSet() < articleCount) {
      this.setState({
        articlesDisplayed: articlesDisplayed + this.checkLimitSet()
      });
    } else {
      this.setState({
        articlesDisplayed: articleCount
      });
    }
  };
  _proto.renderLayout = function renderLayout(article, index) {
    var _this$props = this.props,
      theme = _this$props.theme,
      data = _this$props.data;
    var layout = data.type.toLowerCase();
    var animated = index + 1 > this.checkLimitSet();
    if (layout === 'image' || layout === 'full image') {
      return /*#__PURE__*/_react["default"].createElement(_imageLayout["default"], {
        article: article,
        theme: theme,
        index: index,
        animated: animated,
        layout: layout
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_noImageLayout["default"], {
      article: article,
      theme: theme,
      index: index,
      animated: animated
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      data = _this$props2.data,
      theme = _this$props2.theme;
    var _this$state2 = this.state,
      articleCount = _this$state2.articleCount,
      articlesDisplayed = _this$state2.articlesDisplayed;
    var pageLimit = this.checkLimitSet();
    var checkedArticles = this.checkForArticles();
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, checkedArticles.map(function (article, i) {
      return i + 1 <= articlesDisplayed && /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: i
      }, _this2.renderLayout(article, i));
    }), articleCount > pageLimit && articleCount !== articlesDisplayed && renderEmptyString(data.limit) === ' ' && /*#__PURE__*/_react["default"].createElement(_moreButton["default"], {
      text: renderEmptyString(data.viewMoreLabel),
      theme: theme,
      changeLimitAmount: this.changeLimitAmount
    }));
  };
  return ArticleCards;
}(_react["default"].Component);
exports["default"] = ArticleCards;
ArticleCards.displayName = 'ArticleCards';
ArticleCards.defaultProps = {
  data: _articleListing["default"],
  theme: {}
};